module.exports = __webpack_public_path__ + "img/logo-shiba888.21e9091d.png";